<script setup>

const config = useRuntimeConfig()
const themeStore = useThemeStore()
</script>

<template>
  <div class="mt-0 layout-footer flex align-items-center justify-content-center border-0" style="background: linear-gradient(to right, var(--surface-card) 20%, transparent);">
    <!-- Logo centrato -->
    <div class="col-12 text-center">
      <img
        :src="themeStore.isDarkMode ? `/images/home_icone/logo_footer_tema_scuro.png`: `/images/home_icone/logo_footer_tema_chiaro.png`"
        alt="Redigo Logo"
        class="footer-logo"
      >
    </div>
    <!-- <span class="font-medium ml-2 col text-right">{{ `${appConfig.infoapp.name}` }}</span>
    <span id="image-right" class="ml-2 col-2">
      <img :src="`/images/home_icone/logo_footer_tema_scuro.png`" alt="Image" class="ml-2" style="width: 80px;">
    </span> -->
  </div>
</template>
<style lang="scss">
.layout-footer {
  background: linear-gradient(to right, var(--surface-card) 90%, transparent);
  padding: 1.5rem 0;
  border-top: 1px solid rgba(17, 68, 73, 0.1);
}

.footer-logo {
  max-width: 150px;
  height: auto;
}
</style>
